import Vue from 'vue'
import router from './index'
import { getCookie } from '../utils/tool'

import Router from "vue-router";
/**
 * 工具
 */
// 页面加载进入条
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({
  showSpinner: false
}) // NProgress Configuration
// 工具
import {
  whiteList
} from '@/config'


const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  let userToken = getCookie('token')
  // 检查token
  if (userToken) {
    /* has token */
    if (to.path === '/user/login') {
      next({
        path: '/page/index'
      })
      NProgress.done()
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      sessionStorage.clear();
      next()
    } else {
      next('/page/index')
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})